
import Amplify, { Auth } from 'aws-amplify'
import getEnvironmentConfiguration from '@/config'

export class AmplifyService {
  static getAwsConfigSettings () {
    const {
      REACT_APP_AWS_PROJECT_REGION,
      REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
      REACT_APP_AWS_COGNITO_REGION,
      REACT_APP_AWS_USER_POOLS_ID,
      REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
    } = getEnvironmentConfiguration()

    return {
      aws_project_region: REACT_APP_AWS_PROJECT_REGION,
      aws_cognito_identity_pool_id: REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
      aws_cognito_region: REACT_APP_AWS_COGNITO_REGION,
      aws_user_pools_id: REACT_APP_AWS_USER_POOLS_ID,
      aws_user_pools_web_client_id: REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
    }
  }

  static configure (aws_settings = AmplifyService.getAwsConfigSettings()) {
    if (!process.env.STORYBOOK) {
      Amplify.configure({
        ...aws_settings,
        oauth: {},
      })
    }
  }

  static async fetchCredentials () {
    return Auth.currentCredentials().then()
  }

  /*
    If refresh token is not expired, it'll refresh current session, otherwise,
    it will throw an exception in which we should redirect the user to /auth for login again.
  */
  static async refreshCredentials () {
    const res = await Auth.currentSession()
    return res
  }
}
